export default __webpack_public_path__ + "static/media/Shot_16.0000.89d161ca.png";